import { render } from "./App.vue?vue&type=template&id=d99bb2a4&ts=true"
import script from "./App.vue?vue&type=script&lang=tsx"
export * from "./App.vue?vue&type=script&lang=tsx"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__